import { useMemo, useState } from 'react';

import { resolveSendingFacility, sendingFacilityOptions } from '../helpers/sendingFacility';
import type { SendingFacility, SendingFacilityCustomer } from '../helpers/sendingFacility';

/**
 * L'hôtel au nom duquel le composeur envoie — web ET mobile.
 *
 * Le choix est mémorisé PAR fiche : ouvrir une autre conversation repart de zéro,
 * sans effet de remise à zéro à synchroniser.
 */
export function useSendingFacility(customer?: SendingFacilityCustomer) {
    const [choice, setChoice] = useState<{ customerId: number; facilityId: number } | null>(null);

    const options = useMemo(() => sendingFacilityOptions(customer), [customer]);
    const chosenFacilityId = choice && customer && choice.customerId === customer.id ? choice.facilityId : null;
    const sendingFacility: SendingFacility | null = resolveSendingFacility(options, chosenFacilityId);

    const chooseSendingFacility = (facilityId: number) => {
        if (customer) setChoice({ customerId: customer.id, facilityId });
    };

    return {
        options,
        sendingFacility,
        chooseSendingFacility,
        needsChoice: options.length > 1 && sendingFacility === null,
    };
}
